<template>
  <div v-loading="pageLoading" style="min-height: 150px">
    <no-data v-if="isNoData" />
    <Collapse v-for="(flow,index) in flowList" :key="index">
      <div slot="header">
        <div class="headerItem">
          <i class="iconfont iconweiwuliudan" />
          <span style="margin-left: 25px">发货单号: {{ flow.invoiceNumber }}</span>
        </div>
        <div class="headerItem">
          <span style="display: contents">物流单号:</span> <span style="margin-left: 25px;display: contents;color:#1b73ff;cursor: pointer; " @click.stop="lookLogFlow(flow.logisticsNumber, flow.logisticsCompany)">{{ flow.logisticsNumber }}</span>
        </div>
        <div class="headerItem">
          物流状态: {{ flow.deliverState }}
        </div>
      </div>
      <div v-loading="flow.Loading">
        <div class="rj-row" style="padding:10px 10px 0 10px">
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                起运地：
              </div>
              <div class="rj-baseinfo__item">
                {{ flow.placeDeparture }}
              </div>
            </div>
          </div>
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                到达地：
              </div>
              <div class="rj-baseinfo__item">
                {{ flow.placeArrival }}
              </div>
            </div>
          </div>
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                期望发货日期：
              </div>
              <div class="rj-baseinfo__item">
                {{ flow.carryGoodsDate }}
              </div>
            </div>
          </div>
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                发货日期：
              </div>
              <div class="rj-baseinfo__item">
                {{ flow.deliverGoodsDate }}
              </div>
            </div>
          </div>
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                标准承诺配送天数：
              </div>
              <div class="rj-baseinfo__item">
                {{ flow.distributionDays }} 天
              </div>
            </div>
          </div>
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                预计到货日期：
              </div>
              <div class="rj-baseinfo__item">
                {{ flow.expectedDataArrival }}
              </div>
            </div>
          </div>
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                最终收货单位：
              </div>
              <div class="rj-baseinfo__item">
                {{ flow.destLocationName }}
              </div>
            </div>
          </div>
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                收货人：
              </div>
              <div class="rj-baseinfo__item">
                {{ flow.consigneeName }}
              </div>
            </div>
          </div>
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                最终收货地址：
              </div>
              <div class="rj-baseinfo__item">
                {{ flow.destAddress }}
              </div>
            </div>
          </div>
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                物流公司：
              </div>
              <div class="rj-baseinfo__item">
                {{ flow.logisticsCompany }}
              </div>
            </div>
          </div>
        </div>
        <div class="rj-row" style="padding: 0 10px">
          <div class="rj-col-1">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                备注说明：
              </div>
              <div class="rj-baseinfo__item">
                {{ flow.remark }}
              </div>
            </div>
          </div>
        </div>
        <div v-if="flow.fileServerList.length" class="rj-row" style="padding: 0 10px">
          <div class="rj-col-1">
            <div class="rj-baseinfo" style="height:auto;">
              <div class="rj-baseinfo__label">
                设备签收单：
              </div>
              <div class="rj-baseinfo__item">
                <div style="height: 80px">
                  <div v-for="(file, fileindex) in flow.fileServerList" :key="fileindex" class="qianshouImg">
                    <img :src="`${token.downloadUrl}/${file.fileServerID}?Token=${token.token}`" data-zoomable>
                  </div>
                  <span class="tip">
                    点击可查看大图
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="rj-row" style="padding: 10px">
          <el-table :data="flow.productList" border style="width: 100%">
            <el-table-column type="index" width="70" label="序号" />
            <el-table-column prop="porductCode" label="物品代码" align="left" width="200" />
            <el-table-column prop="productName" label="商品名称" align="left" width="400" />
            <el-table-column prop="number" label="数量" align="left" />
            <el-table-column prop="productUnit" label="单位" align="left" />
            <el-table-column prop="pname" label="是否实物" align="left">
              <template v-slot="{row}">
                {{ row.materialObject=='Y'?'是':row.materialObject=='N'?'否':'' }}
              </template>
            </el-table-column>
            <el-table-column prop="pname" label="查看序列号" align="left">
              <template v-slot="{row}">
                <lookserial-number :str-contract-code="strContractCode" :special-product-list="row.specialProduct" :product-name="row.salesProductName" />
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </Collapse>
    <el-dialog title="物流跟踪信息" :visible.sync="ProcessingVisible" width="520px" top="15px">
      <div v-loading="ProcessingLoading" style="max-height: 800px;min-height: 200px;overflow-y: auto">
        <div v-if="Processing.logisticCode" style="margin-bottom: 15px">
          <span>运单号：{{ Processing.logisticCode }}</span>
        </div>
        <div style="margin-left: 60px">
          <rj-timeline class="Processing">
            <rj-timeline-item v-for="(pro,index) in Processing.traces" :key="index" :color="index!=0?'#909399':''">
              <p> {{ pro.acceptStation }} </p>
              <p> {{ pro.acceptTime }} </p>
              <div v-if="index==0" class="itemState">
                {{ $store.state.enumeration.LogisticsStatus[Processing.state] }}
              </div>
            </rj-timeline-item>
          </rj-timeline>
        </div>
        <no-data v-if="!Processing.logisticCode" />
      </div>
    </el-dialog>
  </div>
</template>
<script type="es6">
import Collapse from '@/components/Collapse';
import lookserialNumber from './lookserialNumber';
import zoom from 'medium-zoom';
import noData from '@/components/noData';
import timeLine from 'rjelement-components/packages/components/timeLine';
import timeLineItem from 'rjelement-components/packages/components/timeLineItem';
import { queryShippingInfoFromDsData, getLogisticsInfoToList, attachmentGetToken } from '@/API';
export default {
  components: {
    Collapse,
    noData,
    lookserialNumber,
    'rj-timeline': timeLine,
    'rj-timeline-item': timeLineItem
  },

  props: {
    strContractCode: {
      type: String,
      required: true
    }
  },

  data () {
    return {
      flowList: [],
      isNoData: false,
      ProcessingVisible: false,
      ProcessingLoading: false,
      Processing: {
        traces: []
      },
      pageLoading: false,
      token: {}
    };
  },

  mounted () {
    this.getjtoken();
    this.iniData();
  },

  methods: {
    getjtoken () {
      attachmentGetToken().then((res) => {
        let json = res.data;
        if (json.status === '200') {
          this.token = json.data;
        }
      });
    },

    iniData () {
      this.pageLoading = true;
      queryShippingInfoFromDsData({ strContractCode: this.strContractCode }).then((res) => {
        let json = res.data;
        this.pageLoading = false;
        if (json.status === '200') {
          this.flowList = json.data;
          this.isNoData = !json.data.length;
          this.setZoomPicture();
        }
      }).catch(() => {
        this.pageLoading = false;
      });
    },

    // 设置图片缩放
    setZoomPicture () {
      this.$nextTick(() => {
        zoom('[data-zoomable]');
      });
    },

    lookLogFlow (val, logisticsCompany) {
      if (val) {
        this.Processing = {
          traces: []
        };
        this.ProcessingVisible = true;
        this.ProcessingLoading = true;
        getLogisticsInfoToList(val, logisticsCompany || '').then((res) => {
          let json = res.data;
          this.ProcessingLoading = false;
          if (json.status === '200') {
            this.Processing = json.data;
          }
        }).catch(() => {
          this.ProcessingLoading = false;
        });
      }
    }
  }

};
</script>
<style lang="scss" scoped>
  @import "../../../../style/var";

  .headerItem{
    float: left;
    margin-right: 40px;
    font-size: 15px;
    :first-child{
      position: absolute;
      top: 14px;
    }
    &:last-child{
      margin-right: 0;
    }
    i{
      font-size: 20px;
      color: $primaryColor;
      margin-right: 5px;
    }
  }
  .headerItem::after{
    content: '';
    clear: both;
    display: block;
    width: 0;
    height: 0;
    visibility: hidden;
  }
  .qianshouImg{
    width: 80px;
    height: 80px;
    display: flex;
    align-items: center;
    margin:0 5px;
    float: left;
    overflow: hidden;
    img{
      width: 100%;
    }
  }
  .tip{
    @include tipText;
    vertical-align: bottom;
    line-height: 80px;
  }
</style>
<style lang="scss">
  @import "../../../../style/var";
  .Processing{
  p{
    margin-bottom: 6px;
  }
  .itemState{
    position: absolute;
    left: -60px;
    top:2px;
  }
  .rj-timeline-item__tail{
    top: 6px;
  }
  .rj-timeline-item{
    padding: 0 0 5px;
  .rj-timeline-item__content{
    color: $--color-text-secondary;
  }
  &:first-child{
  .rj-timeline-item__content{
    color: $--color-primary;
  }
  }
  }
  }
</style>
